<template>
  <b-modal
    class="mc-modal"
    id="mc-modal-driver-cost"
    ref="mc-modal-driver-cost"
    :title="`Catatan Driver FO-12345`"
    size="xl"
    centered
  >
    <div>
      <b-container fluid>
        <McTable
          ref="doTable"
          :fields="fields"
          :apiClient="apiClient"
          withCard
          searchable
          stickyHeader
          class="driver-cost-table"
          :disableSelectAll="true"
          :hasDelete="false"
          @handleSelectValue="handleSelectValue"
        >
          <template #cell(status.name)="{ value, item }">
            <template>
              <span
                v-if="item.status?.color"
                class="__status-dots"
                :style="{ backgroundColor: item.status.color }"
              ></span>
              <span>{{ value }}</span>
            </template>
          </template>

          <template #cell(transaction_date)="{ value }">
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
          </template>

          <template #cell(attachment.filename)="{ value, item }">
            <a class="image-url" :href="item.attachment.url" target="_blank">{{ value }}</a>
          </template>

          <template #cell(transaction_number)="{ value }">
            <span>{{ value !== '' ? value : '' }}</span>
          </template>

        </McTable>
      </b-container>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel"
        />
        <McButton
          variant="primary"
          :text="$t('global.action.apply')"
          :disabled="applyBtnDisabled"
          @click="submit(cancel)"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McTable from '@/components/McTable'
import * as DriverCost from '@/services/rest-api/lib/cost-management/driver-cost'
import { formatIndexDate } from '@/helpers/tzDate'

import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McButton,
    McTable,
  },
  props: {},
  data() {
    return {
      selected: [],
      listLoading: false,
      detailLoading: false,
      fields: [
        { label: 'Tanggal Transaksi', key: 'transaction_date', isSortable: true },
        {
          label: "Kategori Biaya",
          key: 'activity.name',
          isSortable: true,
        },
        {
          label: "Biaya (Rp)",
          key: 'amount',
          isSortable: true,
        },
        {
          label: "Deskripsi",
          key: 'description',
        },
        {
          label: "Lampiran Bukti",
          key: 'attachment.filename',
        },
        {
          label: "Dokumen Biaya",
          key: 'transaction_number',
        },
      ],
    }
  },
  computed: {
    applyBtnDisabled() {
      return this.selected.length === 0
    },
    apiClient() {
      return {
        get: DriverCost.get(),
      }
    },
  },
  methods: {
    formatIndexDate,
    submit(closeCallback) {
      this.$emit('submit', this.selected)

      closeCallback()
    },
    handleSelectValue(ids) {
      this.selected = Object.keys(ids)
        .filter((key) => ids[key] === true)
        .map((id) => id)
    },
  },
}
</script>

<style lang="scss">
@import './style.scss';
</style>
